export default __webpack_public_path__ + "static/media/imone-title-en.b3ce3379.webp";